import { useEffect, useState } from 'react';
import {
  getGoogleAccess,
  subscribeGoogleAccess,
  type GoogleAccessState,
} from '../services/googleAccessService';

/**
 * This person's Google access levels (null until known). Re-reads after any
 * consent anywhere on the page, so a picker opened in one place sees the
 * `read` granted from another.
 */
export function useGoogleAccess(enabled = true): GoogleAccessState | null {
  const [state, setState] = useState<GoogleAccessState | null>(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const load = () => { void getGoogleAccess().then((s) => { if (alive) setState(s); }); };
    load();
    const unsubscribe = subscribeGoogleAccess(load);
    return () => { alive = false; unsubscribe(); };
  }, [enabled]);
  return state;
}
